<template>
    <button class="button flex items-center space-x-2" :disabled="props.busy">
        <slot></slot>
        <IconLoader2 v-if="props.busy" :size="16" class="ml-2 animate-spin" />
    </button>
</template>

<script setup>
    import { IconLoader2 } from '@tabler/icons-vue';

    const props = defineProps({
        busy: Boolean,
    });
</script>
